export default __webpack_public_path__ + "static/media/white_brawn.dd637a59.png";